<ng-container *ngIf="visible$ | async">
    <mat-sidenav-container class="fui-sidebar-container">
        <mat-sidenav
            #matSideNav
            [class]="'fui-sidebar ' + matSideNavCss"
            mode="over"
            position="end"
            [autoFocus]="false"
            (openedChange)="openedChange.emit($event)"
        >
            <!-- Шапка перекрывает закреплённые ячейки вложенных таблиц. -->
            <div class="flex items-center justify-between h-8 bg-surf-container-lowest sticky top-0 z-[var(--z-200)]">
                <div class="flex-1">
                    <p class="m-0 p-2 text-base font-medium leading-tight">{{ title }}</p>
                </div>
                <div class="flex-none p-2">
                    <div class="flex items-center justify-center gap-2 h-full">
                        <fui-button
                            *ngFor="let button of headerButtons$ | async"
                            [type]="button.type ?? 'button-long'"
                            [height]="button.height ?? 'slim'"
                            [borderRadius]="button.borderRadius ?? 'rounded'"
                            [color]="button.color ?? 'flat'"
                            [icon]="button.icon"
                            [label]="button.label"
                            [title]="button.title ?? button.label"
                            [disabled]="button.disabled === true"
                            (clickEvent)="headerButtonClick.emit(button.click ?? '')"
                        ></fui-button>
                        <fui-button
                            type="button-icon"
                            height="slim"
                            borderRadius="circle"
                            color="flat"
                            icon="close"
                            title="{{ appService.language_dictionary.system_close }}"
                            (clickEvent)="closeSideNav()"
                        ></fui-button>
                    </div>
                </div>
            </div>
            <ng-content></ng-content>
        </mat-sidenav>
    </mat-sidenav-container>
</ng-container>
